<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconBreakoutRooms_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M0 5.4A2.4 2.4 0 0 1 2.4 3h19.2A2.4 2.4 0 0 1 24 5.4v13.2a2.4 2.4 0 0 1-2.4 2.4H2.4A2.4 2.4 0 0 1 0 18.6zm3.6 1.2h7.2v4.8H3.6zm7.2 6H3.6v4.8h7.2zm2.4-6h7.2v4.8h-7.2zm7.2 6h-7.2v4.8h7.2z"
        clip-rule="evenodd"
    />
</svg>
